<template>
	<div class="c-product__costs">
		<template v-if="isLoggedIn">
			<template v-if="pricePromo != 0">
				<div class="c-product__price">
					<span class="c-product__price--price"> {{ pricePromo | toCurrency }}</span>
					<span class="c-product__price--yourprice">jouw prijs</span>
				</div>
				<div class="c-product__brutoprice">{{ price | toCurrency }} bruto prijs <span v-if="(priceUnitDescription||priceUnitPluralDescription) && priceQuantity" class="c-product__priceunit">{{ getPriceUnit }}</span></div>
			</template>
			<template v-else>
				<div class="c-product__price">
					<span class="c-product__price--price">{{ price | toCurrency }}</span>
					<span class="c-product__price--yourprice text-muted">Bruto prijs <span v-if="(priceUnitDescription||priceUnitPluralDescription) && priceQuantity" class="c-product__priceunit">{{ getPriceUnit }}</span></span>
				</div>
			</template>
		</template>
		<template v-else>
			<div class="c-product__price">
				<span class="c-product__price--price" data-tooltip="Log in voor jouw prijs">{{ price | toCurrency }} </span>
				<span class="c-product__price--yourprice text-muted">Bruto prijs <span v-if="(priceUnitDescription||priceUnitPluralDescription) && priceQuantity" class="c-product__priceunit">{{ getPriceUnit }}</span></span>
				
			</div>
		</template>
	</div>
</template>

<script>
export default {
	props: {
		isLoggedIn: {
			type: Boolean,
			required: true
		},
		pricePromo: {
			type: Number,
			default: 0
		},
		price: {
			type: Number,
			required: true
		},
		priceUnit: {
			type: String,
			required: false
		},
		priceUnitDescription: {
			type: String,
			required: false
		},
		priceUnitPluralDescription: {
			type: String,
			required: false
		},
		priceQuantity: {
			type: Number,
			required: false
		},
		priceOrderRatio: {
			type: Number,
			required: false,
			default: 0
		}
	},
	computed: {
		getPriceUnit() {
			// const priceunit = "per " + this.priceQuantity + ' ' + this.priceUnit
			let priceunit = '';
			if(parseInt(this.priceQuantity) > 1){
				priceunit = "per " + this.priceQuantity + ' ' + this.priceUnitPluralDescription;
			}
			else{
				priceunit = "per " + this.priceQuantity + ' ' + this.priceUnitDescription;
			}			
			return priceunit;
		}
	},
};
</script>
